import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { endpoints } from 'src/environments/endpoints';
import {
  AtualizarCredencialRpaPayload,
  AvisoRpa,
  CredencialRpa,
} from '../../models/credencial-rpa/CredencialRpa';

@Injectable({
  providedIn: 'root',
})
export class CredencialRpaService {
  http = inject(HttpClient);

  /**
   * Avisos da empresa selecionada. Nao precisa passar a empresa: o
   * auth.interceptor ja injeta o header `guidEmpresa` em toda requisicao, entao
   * a resposta muda sozinha quando a pessoa troca de empresa.
   */
  getAvisos(): Observable<AvisoRpa[]> {
    return this.http.get<AvisoRpa[]>(`${endpoints.credencialRpa}/avisos`);
  }

  getCredenciais(): Observable<CredencialRpa[]> {
    return this.http.get<CredencialRpa[]>(`${endpoints.credencialRpa}/listar`);
  }

  atualizarCredencial(
    chave: string,
    payload: AtualizarCredencialRpaPayload
  ): Observable<void> {
    return this.http.put<void>(`${endpoints.credencialRpa}/${chave}`, payload);
  }
}
